export default __webpack_public_path__ + "static/media/Icon feather-sun.b33c5402.svg";